/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum InputTypeEnum {
    TEXT = 'InputTextComponent',
    DROPDOWN = 'InputDropdownComponent',
    AUTOCOMPLETE = 'InputAutocompleteComponent',
    DATE = 'InputDateComponent',
    TEXTAREA = 'InputTextareaComponent',
    UNITS = 'InputUnitsComponent',
    MULTI_SELECT = 'InputMultiSelectComponent'
}
